import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import authApiService from "@/services/api/AuthApiService";
export default {
  data: function data() {
    return {
      phone: "",
      loggingIn: false
    };
  },
  methods: {
    login: function login() {
      var _this = this;

      this.loggingIn = true;
      this.$vs.loading();
      authApiService.login(this.phone).then(function () {
        _this.$emit("send-phone", _this.phone);
      }).catch(function (err) {
        var message = err.getErrorDescriptions();

        switch (err.status) {
          case 403:
            message = "شما اجازه دسترسی به این پنل را ندارید";
            break;

          case 404:
            message = err.error.response.data.message || "شماره همراه معتبر نیست";
            break;
        }

        _this.$vs.notify({
          text: message,
          color: "danger",
          position: "bottom-center"
        });

        if (err.status === 403) {
          _this.phone = "";
        }
      }).finally(function () {
        _this.loggingIn = false;

        _this.$vs.loading.close();
      });
    }
  }
};